import { Button, Divider, Drawer, Tabs, Tooltip, Typography } from 'antd';
import classNames from 'classnames';
import React, { forwardRef, useEffect, useState } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { ADVANCED_ITEMS, ITEMS } from '../../../constants';

import DragIndicatorIcon from '../../../assets/icons/drag-indicator.svg';
import './style.less';
import { PlusOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import { isMobileDevice } from '../../../utils/helpers';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line react/display-name
const Item = forwardRef(({ item, t, ...props }, ref) => (
  <div ref={ref} {...props}>
    <span style={{ width: 25, height: 25 }}>
      <img src={item?.icon} alt="drag icon" style={{ width: 25, borderRadius: 3, padding: 5 }} />
    </span>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography.Text className="sub-title">
        {t(`items.${item.key}.content`, item.content)}
      </Typography.Text>
      {/* <span className="sub-desc">{item.desc}</span> */}
    </div>
    <img
      src={DragIndicatorIcon}
      alt="drag icon"
      style={{ height: 14, marginLeft: 'auto', marginRight: '3px' }}
    />
  </div>
));

const DragableItems = ({ items, droppableId, add }) => {
  const { t } = useTranslation(['builder']);

  return (
    <Droppable droppableId={droppableId} type="QUESTION" isDropDisabled={true}>
      {(provided) => (
        <div className="toolbar-content" ref={provided.innerRef} {...provided.droppableProps}>
          {items.map((item, index) =>
            item.type !== 'SEPERATOR' ? (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => (
                  <>
                    <Item
                      className={classNames('item', {
                        dragging: snapshot.isDragging,
                      })}
                      onClick={() => add(item)}
                      item={item}
                      t={t}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={provided.draggableProps.style}
                    />
                    {snapshot.isDragging && <Item className="item clone" item={item} t={t} />}
                  </>
                )}
              </Draggable>
            ) : (
              <Divider key={item.id} style={{ margin: '2px 0' }} />
            ),
          )}
          {/* {provided.placeholder} */}
        </div>
      )}
    </Droppable>
  );
};

const QuestionsPanel = ({ addFormElement, visible, setVisible, previewMode }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isMobileSmall = useMediaQuery({ maxWidth: 576 });
  const [tooltipVisible, setTooltipVisible] = useState(true);
  const { t } = useTranslation(['builder']);

  useEffect(() => {
    if (isMobile) setTooltipVisible(true);
    const delay = setTimeout(() => {
      setTooltipVisible(false);
    }, 5000);
    return () => {
      clearTimeout(delay);
    };
  }, [isMobile]);

  const onAddButtonClick = () => {
    setTooltipVisible(false);
    // if (!isWidthScreen) setPropertiesVisible(false);
    setVisible(true);
  };
  const titleText = isMobileSmall
    ? t('questionPanel.headerMobile', 'Click to add questions')
    : t('questionPanel.header', 'Add Questions');
  const panelTitle = <Typography.Text className="sub-title">{titleText}</Typography.Text>;

  return (
    <div className="Questions-panel">
      <Drawer
        title={panelTitle}
        placement="left"
        closable={true}
        onClose={() => setVisible(!visible)}
        // closeIcon={<CloseIcon />}
        visible={visible}
        getContainer={false}
        mask={false}
        width={isMobile ? '100%' : 250}
        className="fields-panel"
        // style={{ position: 'fixed', top: isDesktop ? 140 : 188 }}
        headerStyle={{ padding: '20px 20px 16px' }}
        contentWrapperStyle={{
          boxShadow: !isDesktop ? 'rgba(0, 0, 0, 0.16) 0px 1px 4px' : 'none',
          borderRight: !isDesktop ? 'none' : '2px solid #ecebee',
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Tabs
          defaultActiveKey={1}
          className="question-tabs"
          // style={{ marginTop: -8 }}
          // onChange={onImageTabChange}
        >
          <Tabs.TabPane tab={t('builder:questionPanel.basicFields')} key="1">
            <div style={{ paddingInline: '4px 10px' }}>
              <DragableItems add={addFormElement} items={ITEMS} droppableId="ITEMS" />
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('builder:questionPanel.AdvancedFields')} key="2">
            <div style={{ paddingInline: '4px 10px' }}>
              <DragableItems
                add={addFormElement}
                items={ADVANCED_ITEMS}
                droppableId="ADVANCED_ITEMS"
              />
            </div>
          </Tabs.TabPane>
        </Tabs>
        {/* <DragableItems add={addFormElement} /> */}
      </Drawer>
      {!visible && !previewMode && (
        <Tooltip
          title={t('questionPanel.header', 'Add Questions')}
          placement="right"
          visible={isMobile && isMobileDevice() ? tooltipVisible : undefined}
        >
          <Button
            className="collapse-button"
            icon={<PlusOutlined />}
            type={'primary'}
            shape="circle"
            onClick={onAddButtonClick}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default QuestionsPanel;
